import React, { useEffect, useState } from "react";
import NavbarHeader from "../../../Navbarheader/NavbarHeader";
import Footer from "../../../Footer/Footer";
import HeroSection from "./components/Herosection";
import Intro from "./components/Intro";
import Moreintro from "./components/Moreintro";

import Bannermockup from "./components/Bannermockup";

import NextProjectButton from "../components/NextProjectButton";

import { useNavigate } from 'react-router-dom';

function Amabills() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
 const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleNextProjectClick = () => {
    navigate('/project/adept');
  };

  

  return (
    <div fluid className="scroll-container">
      <NavbarHeader />
      <div
        style={{
          backgroundColor: "#101010",
          paddingTop: isSmallScreen ? "7rem" : "0px",
        }}
      >
        <HeroSection />
        <Intro />
        <Moreintro />
       
        <Bannermockup />
       
        <div id="showNextButton">
          Last component
        </div>
      </div>
      <Footer />

      <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />

     
    </div>
  );
}

export default Amabills;
